var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcoArrowDown(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 9.406,
    height: 6.422,
    viewBox: "0 0 9.406 6.422",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#040405;stroke:#040405;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.703 0.711)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M1743.917,408.352l-3.06,3.09-3.06-3.09-.94.951,4,4.049,4-4.049Z",
    transform: "translate(-1736.857 -408.352)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoArrowDown);
export default __webpack_public_path__ + "static/media/ico-arrow-down.bc3d13df4d89cf903d602f7dde80c84e.svg";
export { ForwardRef as ReactComponent };